<template>
  <GridSkeleton has-state v-if="loading"/>
  <div v-else-if="orders.length > 0" class="grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-5">
    <div v-for="(order, index) in orders" :key="index"
         class="bg-white dark:bg-slate-800 p-4 relative z-[1] rounded-2xl text-white flex flex-col justify-between overflow-hidden gap-4 cursor-default border border-slate-200 dark:border-slate-700"
         :class="{ 'hover:outline hover:outline-1 hover:outline-primary-500 dark:hover:outline-primary-500': order.state === 'Delivering',
               'hover:outline hover:outline-1 hover:outline-success-600 dark:hover:outline-success-500': order.state === 'Delivered',
               'hover:outline hover:outline-1 hover:outline-danger-600 dark:hover:outline-danger-600': order.state === 'Canceled'}"
    >
      <div class="w-full">
        <div class="dir-ltr mb-1 flex flex-row justify-between items-start">
            <span class="dir-ltr text-left text-[14px] text-slate-900 dark:text-white mb-2 me-2">
              {{ order.game }}
            </span>
          <span
              class="w-max text-[10px] font-medium px-3 py-1 rounded-full h-auto text-nowrap"
              :class="{ 'bg-primary-500 text-slate-100': order.state === 'Delivering',
               'bg-success-600 text-slate-100': order.state === 'Delivered',
               'bg-danger-600 text-slate-100': order.state === 'Canceled'}">
              {{ $t('message.' + (order.state.charAt(0).toLowerCase() + order.state.slice(1))) }}
            </span>
        </div>
        <p class="dir-ltr text-[13px] font-medium text-slate-900 dark:text-white text-opacity-80 break-words">
          {{ order.title }}
        </p>
      </div>
      <div class="flex flex-col gap-4 relative">
        <div class="flex flex-row justify-between">
          <p class="text-success text-[12px] font-weight-bolder text-lime-600">
            {{ getFormattedDate(order.creationTime) }}
          </p>
          <h6 class="text-[13px]">
            {{ locale === 'fa' ? order.price + ' دلار' : '$' + order.price }}
          </h6>
        </div>
      </div>
      <div class="absolute right-0 top-0" v-if="order.userApplied">
        <Tooltip
            placement="top"
            arrow
        >
          <template v-slot:button>
              <span
                  class="absolute right-0 top-0 text-xl text-info-600 px-2 py-2 rounded-full inline-block uppercase h-auto opacity-60">
            <Icon icon="mdi:progress-tick"></Icon>
          </span>
          </template>
          <template v-slot:default>
            {{ $t('message.you reserved this order') }}
          </template>
        </Tooltip>
      </div>
      <img v-if="themeSettingsStore.isDark"
           src="@/assets/images/svg/line.svg"
           alt=""
           class="absolute left-0 bottom-0 w-full z-[-1] opacity-50"
      />
      <img v-else
           src="@/assets/images/svg/line-dark.svg"
           alt=""
           class="absolute left-0 bottom-0 w-full z-[-1] opacity-50"
      />
    </div>
  </div>
  <div v-else
       class="flex justify-center flex-wrap items-center flex-col text-center gap-10"
  >
    <img width="220" src="@/assets/images/all-img/no-data1.png" alt=""/>
    <p class="font-normal text-base text-slate-500 dark:text-slate-300">
      {{ $t('message.there is no order to show') }}
    </p>
  </div>
</template>

<script setup>
import Card from "@/components/Card/index.vue";
import Icon from "@/components/Icon/index.vue";
import {useOrdersStore} from "@/stores/orders.js";
import {computed, ref} from "vue";
import {useManagementStore} from "@/stores/management.js";
import Button from "@/components/Button/index.vue";
import jalaliMoment from "jalali-moment";
import {useI18n} from "vue-i18n";
import Tooltip from "@/components/Tooltip/index.vue";
import {useThemeSettingsStore} from "@/stores/themeSettings";
import GridSkeleton from "@/components/Skeleton/Orders.vue";

const themeSettingsStore = useThemeSettingsStore()
const {t, locale} = useI18n({useScope: 'global'})
const managementStore = useManagementStore();
const orderStore = useOrdersStore()
const selectedApplicant = computed(() => managementStore.getSelectedApplicant);
const orders = ref([])
const loading = ref(false)

const getFormattedDate = (timestamp) => {
  const date = new Date(timestamp);
  const jalaliDate = jalaliMoment(date);
  return locale.value === 'fa'
      ? jalaliDate.locale('fa').format('jYYYY/jMM/jDD')
      : jalaliDate.format('YYYY/MM/DD')
}

async function get_taker_orders() {
  loading.value = true
  orders.value = await orderStore.action_get_taker_currency_sell_orders({takerID: selectedApplicant.value.id})
  loading.value = false
}

get_taker_orders()
</script>

<style scoped lang="scss">
.date-label {
  @apply text-xs text-slate-400 dark:text-slate-400 mb-1;
}

.date-text {
  @apply text-xs text-slate-600 dark:text-slate-300 font-medium;
}

.dir-ltr {
  direction: ltr;
}

.dir-rtl {
  direction: rtl;
}
</style>